/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  Form,
  Input,
  Row,
} from 'antd';
import InputSearch from 'components/InputSearch';
import LadaNumero from 'components/LadaNumero';
import { avilablePadrones } from 'components/PadronesInfo';
import Select from 'components/Select';
import React from 'react';
import { getHelpTexts } from 'utils/padrones';
import { padronesEnum } from 'views/Tramites/GPM/enums';

const FormBusqueda = ({
  form,
  padron,
  tipoDePadronSelected,
  setTipoDePadronSelected,
  onFinish,
  rules,
  collapsedSidebar,
  visibleBusquedaPadrones,
  setVisibleBusquedaPadrones,
  dataExterno,
  setDataExterno,
  padron_principal,
  padrones,
}) => (
  <Form
    layout="vertical"
    form={form}
    onFinish={() => onFinish()}
    scrollToFirstError
    initialValues={{ padron: padron_principal }}
    className={padron ? 'without-feedback' : ''}
  >
    <Row gutter={10}>
      {!padron && (
      <>
        <Col
          xs={24}
          sm={24}
          md={8}
        >
          <Form.Item
            name="padron"
            label="Padrón"
            hasFeedback
            rules={rules.required}
          >
            <Select
              onChange={setTipoDePadronSelected}
              dataSource={padrones.filter((e) => e.id !== 5)}
            />
          </Form.Item>
        </Col>
        {tipoDePadronSelected && (
        <Col
          xs={24}
          sm={24}
          md={collapsedSidebar ? 8 : 16}
        >
          <InputSearch
            disabled={false}
            label={padrones
              .find((e) => e.id === tipoDePadronSelected)?.descripcion}
            rules={rules.required}
            tipoDePadron={tipoDePadronSelected}
            visibleBusquedaPadrones={visibleBusquedaPadrones}
            setVisibleBusquedaPadrones={setVisibleBusquedaPadrones}
            setDataExterno={setDataExterno}
            dataExterno={dataExterno}
            onChange={({ target: { value } }) => form.setFieldsValue({ q: value })}
            onPressEnter={() => onFinish()}
            title={getHelpTexts(tipoDePadronSelected)}
            onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
          />
        </Col>
        )}
      </>
      )}
      {padron && !avilablePadrones.includes(tipoDePadronSelected) && (
        <>
          {([padronesEnum.CIUDADANO, padronesEnum.CONTRIBUYENTE]
            .includes(tipoDePadronSelected)) && (
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                label="Clave"
                name={tipoDePadronSelected === 1 ? 'clave_ciudadana' : 'clave'}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          )}
          {tipoDePadronSelected !== padronesEnum.MOTOCICLETA && (
          <Col xs={24} sm={24} md={tipoDePadronSelected === padronesEnum.PREDIO ? 12 : 16}>
            <Form.Item
              label={tipoDePadronSelected !== 4 ? 'Nombre' : 'Placas/Serie'}
              name="_nombre_completo"
            >
              <Input disabled />
            </Form.Item>
          </Col>
          )}
          {![
            padronesEnum.MOTOCICLETA,
            padronesEnum.VEHICULO,
            padronesEnum.PREDIO,
          ].includes(tipoDePadronSelected) && (
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="RFC"
              name="RFC"
            >
              <Input disabled />
            </Form.Item>
          </Col>
          )}
          {([padronesEnum.CIUDADANO, padronesEnum.CONTRIBUYENTE]
            .includes(tipoDePadronSelected)) && (
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                label="CURP"
                name="CURP"
              >
                <Input disabled />
              </Form.Item>
            </Col>
          )}
          {(tipoDePadronSelected === padronesEnum.PREDIO) && (
          <>
            <Col
              xs={24}
              sm={24}
              md={!padron?.ciudadano
                && padron.nombres_de_participes?.length === 1 ? 8 : 12}
            >
              <Form.Item
                label={`Propietario${padron.nombres_de_participes?.length > 1 ? 's' : ''}`}
                name="_propietario"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Dirección"
                name="direccion"
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </>
          )}
          {![
            padronesEnum.MOTOCICLETA,
            padronesEnum.VEHICULO,
            padronesEnum.PREDIO,
          ].includes(tipoDePadronSelected) && (
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Correo"
              rules={rules.email}
              name="email"
            >
              <Input disabled />
            </Form.Item>
          </Col>
          )}
          {![
            padronesEnum.MOTOCICLETA,
            padronesEnum.VEHICULO,
          ].includes(tipoDePadronSelected) && (
          <LadaNumero
            rules={rules}
            form={form}
            names={{
              lada: 'lada',
              numero_de_telefono: 'numero_de_celular',
            }}
            disabled
          />
          )}
          {tipoDePadronSelected === padronesEnum.VEHICULO && (
          <>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="clase_del_vehiculo"
                label="Clase"
              >
                <Select disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="servicio"
                label="Servicio"
              >
                <Select disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="tipo_de_vehiculo"
                label="Tipo de Vehículo"
              >
                <Select disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="linea"
                label="Línea"
              >
                <Select disabled />
              </Form.Item>
            </Col>
          </>
          )}
          {tipoDePadronSelected === padronesEnum.MOTOCICLETA && (
          <>
            <Row gutter={10}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Clave"
                  name="clave"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Número de Placa"
                  name="numero_de_placa_vigente"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  name="serie"
                  label="Serie"
                  tooltip="Número de Serie de la Motocicleta"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Registro Publico"
                  name="registro_publico_vehicular"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Tarjeta de Circulación"
                  name="tarjeta_de_circulacion"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>

            </Row>
          </>
          )}
          {tipoDePadronSelected === padronesEnum.REMOLQUE && (
          <>
            <Row gutter={10}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Clave"
                  name="clave"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Número de Placa"
                  name="numero_de_placa_vigente"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  name="serie"
                  label="Serie"
                  tooltip="Número de Serie de la Motocicleta"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Registro Publico"
                  name="registro_publico_vehicular"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Tarjeta de Circulación"
                  name="tarjeta_de_circulacion"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
            </Row>
          </>
          )}
        </>
      )}
      <Form.Item name="id" hidden>
        <Input disabled />
      </Form.Item>
    </Row>
    <Form.Item hidden>
      <Button htmlType="submit" />
    </Form.Item>
  </Form>
);

export default FormBusqueda;
